import { inject as L, ref as N, computed as n, createBlock as j, createElementBlock as p, openBlock as i, unref as x, mergeProps as c, withCtx as C, renderSlot as d } from "vue";
import { RouterLink as R } from "vue-router";
const W = ["href", "target", "rel", "aria-label", "download"], E = "link-clicked", I = /* @__PURE__ */ Object.assign({
  name: "DsAnchorElement"
}, {
  __name: "anchor-element",
  props: {
    /**
     * trackingData, to be set as data-track attributes for tracking purpose
     */
    trackingData: { type: Object, default: () => ({}) },
    /**
     * url, href attribute content
     */
    url: { type: String, required: !1, default: null },
    /**
     * openInNewWindow, when is set to true it will open the link in a new window
     */
    openInNewWindow: { type: Boolean, default: !1 },
    /**
     * nuxt, when is set to true it will render a nuxt link (vue router link)
     */
    nuxt: { type: Boolean, default: !0 },
    /**
     * prefetch, when is set to true it will nuxt will prefetch the page
     */
    prefetch: { type: Boolean, default: !0 },
    /**
     * ariaLabel, arial-label attribute content
     */
    ariaLabel: { type: String, default: "" },
    /**
     * download, adds download attribute
     */
    download: { type: Boolean, required: !1, default: null }
  },
  emits: ["link-clicked"],
  setup(t, { emit: B }) {
    const l = t, D = B, f = L("trackEvent", null), s = N(), k = n(() => l.openInNewWindow ? "_blank" : null), g = n(() => l.openInNewWindow ? "noopener" : null), o = (e) => {
      var b, w, h, y;
      const a = ((h = (w = (b = e == null ? void 0 : e.target) == null ? void 0 : b.innerText) == null ? void 0 : w.replace(/(\r\n|\n|\r)/gm, " ")) == null ? void 0 : h.trim()) || ((y = e == null ? void 0 : e.target) == null ? void 0 : y.ariaLabel), r = {
        url: l.url,
        ...a && { label: a }
      };
      f ? f(E, r, e == null ? void 0 : e.currentTarget) : D(E, r);
    }, u = n(() => l.trackingData ? Object.keys(l.trackingData).reduce((e, a) => {
      const r = `data-track-${a}`;
      return e[r] || (e[r] = l.trackingData[a]), e;
    }, {}) : {}), m = n(() => {
      var e;
      return l.nuxt ? (e = l.url) == null ? void 0 : e.startsWith("http") : !0;
    });
    return (e, a) => t.url && !m.value ? (i(), j(x(R), c({
      key: 0,
      ref_key: "linkRef",
      ref: s,
      to: t.url,
      target: k.value,
      rel: g.value,
      "aria-label": t.ariaLabel,
      prefetch: t.prefetch,
      download: t.download ? "" : null
    }, u.value, { onClick: o }), {
      default: C(() => [
        d(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["to", "target", "rel", "aria-label", "prefetch", "download"])) : t.url && m.value ? (i(), p("a", c({
      key: 1,
      ref_key: "linkRef",
      ref: s,
      href: t.url,
      target: k.value,
      rel: g.value,
      "aria-label": t.ariaLabel
    }, u.value, {
      download: t.download ? "" : null,
      onClick: o
    }), [
      d(e.$slots, "default")
    ], 16, W)) : (i(), p("button", c({ key: 2 }, u.value, { onClick: o }), [
      d(e.$slots, "default")
    ], 16));
  }
});
export {
  I as default
};
